import React from 'react';
import { Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    organization: [
      { name: 'Über uns', href: '#mission' },
      { name: 'Unsere Mission', href: '#mission' },
      { name: 'Projekte', href: '#projects' },
      { name: 'Kontakt', href: '#contact' }
    ],
    legal: [
      { name: 'Impressum', href: '/impressum', isRoute: true },
      { name: 'Statuten', href: 'https://customer-assets.emergentagent.com/job_209657ca-8f09-4790-bace-16f92542669d/artifacts/0677o1i3_Statuten_Web_TLC_V.2026.04.15.pdf', isExternal: true }
    ]
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_b449bff2-a271-4cbe-9cad-1f6cd5dbd33a/artifacts/y4otwih5_20251110%20tl%20charity%20design%20%26%20identity%20V01-02.png"
              alt="TL Charity Logo"
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Gemeinsam schützen wir bedrohte Wälder weltweit und bewahren Lebensräume für Tiere und Menschen.
            </p>
            <div className="mb-6 p-4 bg-white/5 rounded-lg border border-white/10">
              <h4 className="text-white font-semibold mb-2 text-sm">Direktspenden</h4>
              <p className="text-gray-400 text-xs mb-1">Postkonto</p>
              <p className="text-gray-300 text-sm font-mono">CH84 0900 0000 1676 8544 4</p>
            </div>
          </div>

          {/* Organization */}
          <div>
            <h3 className="text-lg font-bold mb-4">Organisation</h3>
            <ul className="space-y-3">
              {footerLinks.organization.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-[#FF9B8C] transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-bold mb-4">Rechtliches</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  {link.isRoute ? (
                    <button
                      onClick={() => navigate(link.href)}
                      className="text-gray-400 hover:text-[#FF9B8C] transition-colors duration-300"
                    >
                      {link.name}
                    </button>
                  ) : link.isExternal ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-[#FF9B8C] transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-[#FF9B8C] transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} Trees Life Charity. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-2 text-gray-400 text-sm">
            <span>Gemacht mit</span>
            <Heart className="h-4 w-4 text-[#FF1B8D] fill-current" />
            <span>für unseren Planeten</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
